import { createContext, useContext } from 'react';

import { DEFAULT_QUERY_BUILDER_LABELS } from './defaultLabels';
import type { QueryBuilderConfig } from './types';

const DEFAULT_CONFIG: QueryBuilderConfig = {
  labels: DEFAULT_QUERY_BUILDER_LABELS,
  allowNestedGroups: true,
  maxNestingDepth: undefined,
  groupActionsPosition: 'bottom',
  elementLayout: 'wrap',
  hideFieldSelect: false,
  hideOperatorSelect: false,
  hideNegate: false,
  allowMultipleValues: true,
  classNames: {}
};

const QueryBuilderConfigContext = createContext<QueryBuilderConfig>(DEFAULT_CONFIG);

export const QueryBuilderConfigProvider = QueryBuilderConfigContext.Provider;

/** Every nested LogicGroupEditor/LogicElementEditor reads customization
 * (labels, nesting rules, positioning, classNames) from here instead of
 * threading it through every recursive call. */
export const useQueryBuilderConfig = () => useContext(QueryBuilderConfigContext);
